import styled from 'styled-components';
import { tokens } from '@mindtickle/styles/lib';

export const StyledProfileDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 24px 8px 24px;
  cursor: auto;
  width: 284px;
  justify-content: flex-start;
  align-items: flex-start;

  .profile-user-name-ellipsis {
    width: 100%;
    padding: 6px 0;
  }

  .view-profile {
    cursor: pointer;
    padding: 4px 0;
    &:hover {
      color: ${tokens.textTokens.COLOR_TEXT_ACCENT};
    }
  }
`;
